(() => {
  if (window.mwyCardEdgeLoaded) return;
  window.mwyCardEdgeLoaded = true;
  let frame = 0;
  function update() {
    frame = 0;
    const viewport = window.visualViewport;
    const height = viewport && viewport.scale === 1 ? viewport.height : innerHeight;
    const element = document.elementFromPoint(innerWidth / 2, Math.max(1, Math.min(innerHeight, height) - 2));
    const card = element?.closest('.mwy-album-card--mobile[data-mwy-album-card]');
    const html = document.documentElement;
    if (card) {
      html.style.setProperty('--mwy-card-bottom-edge', getComputedStyle(card).backgroundColor);
      html.classList.add('mwy-card-bottom-edge-active');
    } else {
      html.classList.remove('mwy-card-bottom-edge-active');
      html.style.removeProperty('--mwy-card-bottom-edge');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  // Capture also covers the homepage's internal scroll container.
  document.addEventListener('scroll', schedule, {capture:true, passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
